import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout, { ContentSection } from '../components/Layout';
import LEOTemplate from './leo-template';

function LEOPage({ uri, data }) {
  const { title, description, image } = data.markdownRemark.frontmatter;

  const stateLinks = {};
  /* eslint-disable camelcase */
  data.allVoteAmericaStateInformation.nodes.forEach(
    ({ state, text, field_type }) => {
      if (!stateLinks[state]) {
        stateLinks[state] = {};
      }

      stateLinks[state][field_type] = text;
    }
  );

  return (
    <Layout
      title={title}
      description={description}
      image={image}
      canonicalPath='/local-election-offices/'
    >
      <ContentSection>
        <LEOTemplate
          uri={uri}
          description={description}
          stateLinks={stateLinks}
        />
      </ContentSection>
    </Layout>
  );
}

LEOPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        image: PropTypes.string,
      }),
    }),
    allVoteAmericaStateInformation: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string,
          nodes: PropTypes.arrayOf(
            PropTypes.shape({
              text: PropTypes.string,
              field_type: PropTypes.string,
            })
          ),
        })
      ),
    }),
  }),
  uri: PropTypes.string.isRequired,
};

export default LEOPage;

export const pageQuery = graphql`
  query LEOPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        description
        image
      }
    }
    allVoteAmericaStateInformation(
      sort: { state_name: ASC }
      filter: {
        field_type: {
          in: ["gov_tool_absentee_tracker", "gov_tool_polling_place"]
        }
      }
    ) {
      nodes {
        state
        field_type
        text
      }
    }
  }
`;
